export const researchPath = (asset, symbol, reportId) => {
  const query = new URLSearchParams({ asset, symbol });
  if (reportId) query.set('report', reportId);
  return `${asset === 'stock' ? '/stocks' : '/research'}?${query}`;
};

export const scannerPath = (market, runId) => `${market === 'crypto' ? '/scanner' : '/stocks/scanner'}${runId ? `?run=${encodeURIComponent(runId)}` : ''}`;